<script setup lang="ts">
import BaseModal from './ui/BaseModal.vue'
import GiftBoxApp from './GiftBoxApp.vue'

interface Props {
  isOpen: boolean
}

const props = defineProps<Props>()
const emit = defineEmits<{
  close: []
}>()

const closeModal = () => {
  emit('close')
}
</script>

<template>
  <BaseModal
    :open="isOpen"
    max-width="480px"
    :close-on-backdrop="false"
    @close="closeModal"
  >
    <div class="giftbox-content">
      <GiftBoxApp @close="closeModal" />
    </div>
  </BaseModal>
</template>

<style scoped>
.giftbox-content {
  /* Fixed height to prevent jumping between steps */
  min-height: 600px;
}

@media (max-width: 640px) {
  .giftbox-content {
    min-height: 500px;
  }
}
</style>
